import { z } from "zod";
import {
  ACTIVE,
  COMMUNITY_ID,
  DESCRIPTION,
  DOCUMENT_TYPE,
  DOCUMENT_TYPE_ID,
  TRANSACTIONAL_PROCESSOR,
  UPDATED_AT,
  UPDATED_BY,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_TYPE_ID]: z.string().optional(),
  [DOCUMENT_TYPE]: z.string().min(2, "Minimum Length of this field is 2"),
  [TRANSACTIONAL_PROCESSOR]: z
    .string()
    .min(2, "Minimum Length of this field is 2"),
  [ACTIVE]: z.boolean().optional(),
  [DESCRIPTION]: z.string().optional(),
  [UPDATED_AT]: z.string().optional(),
  [UPDATED_BY]: z.string().optional(),
  [COMMUNITY_ID]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
